module.exports = __webpack_public_path__ + "01_glasses_black.55981708.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/boy/layer4/01_glasses_black.png
// module id = wsDR
// module chunks = 0